"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StrictTypeGuard = exports.StrictTypeMismatchError = void 0;
class StrictTypeMismatchError extends Error {
    constructor(expected, actual) {
        super(`Strict type mismatch: expected exact type ${expected.name} but received ${actual.name}. ` +
            `Subclass instances are not allowed — the object's constructor must be identical.`);
        this.name = 'StrictTypeMismatchError';
    }
}
exports.StrictTypeMismatchError = StrictTypeMismatchError;
class StrictTypeGuard {
    constructor(enforcedType) {
        this.enforcedType = enforcedType;
    }
    get type() {
        return this.enforcedType;
    }
    assertType(value) {
        const actualCtor = value.constructor;
        if (this.enforcedType === undefined) {
            this.enforcedType = actualCtor;
            return;
        }
        if (actualCtor !== this.enforcedType) {
            throw new StrictTypeMismatchError(this.enforcedType, actualCtor);
        }
    }
}
exports.StrictTypeGuard = StrictTypeGuard;
//# sourceMappingURL=StrictTypeGuard.js.map